<template>
    <label v-if="state" class="label">
        <input type="checkbox" class="checkbox" :checked="surrounding" @input="switchFacet">
        <div class="label-text">Surrounding towns?</div>
    </label>
</template>

<script>
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors';
import { createWidgetMixin } from 'vue-instantsearch';

export default {
    mixins: [
        createWidgetMixin({ connector: connectCurrentRefinements }),
    ],

    props: {
        surrounding: {
            type: Boolean,
            required: true
        },

        regionFacet: {
            type: String,
            required: true,
        },

        surroundingFacet: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            firstRun: true,
            enableSurrounding: true,
        };
    },

    computed: {
        widgetParams() {
            return {
                includedAttributes: [this.regionFacet, this.surroundingFacet],
            };
        },
    },

    watch: {
        'state.items': function (value) {
            if (this.firstRun && value.length) {
                this.firstRun = false;
                const surrounding = value[0].attribute === this.surroundingFacet;
                this.$emit('switch', { surrounding });
            }
        },
    },

    methods: {
        switchFacet(event) {
            let values = [];

            if (this.state && this.state.items.length) {
                values = this.state.items.flatMap((item) => {
                    return item.refinements.map((refinement) => refinement.value);
                });
            }

            this.$emit('switch', { towns: values, surrounding: event.target.checked });
        }
    }
};
</script>

<style lang="scss" scoped>
    .label {
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .checkbox {
        appearance: none;
        cursor: pointer;
        display: inline-block;
        width: 24px;
        height: 24px;
        margin: 0;
        border: 2px solid getColor("sand", "base");
        border-radius: 0;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        transition: all .3s;

        &:checked {
            border-color: getColor("blue", "charcoal");
            background-image: url('../assets/images/tick.svg');
        }

        @include media-query(smart) {
            width: 20px;
            height: 20px;
        }
    }

    .label-text {
        display: flex;
        font-size: 16px;
        font-weight: 400;
        color: getColour("grey", "dark");
        cursor: pointer;
        padding-left: 10px;

        @include media-query(smart) {
            font-size: 13px;
        }
    }

</style>
